import { useEffect, useState } from "react";
import styled from "styled-components";
import { firstImage, secondImage } from "../assets/hero/images";
import Cubes from "./Cubes";
import ScrollButton from "./ScrollButton";

const StyledHero = styled.div`
  width: 100%;
  height: 100vh;
  background: var(--bg);
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  @media (max-width: 600px) {
    display: none;
  }
`;

const SvgContainer = styled.div`
  height: 85vh;
`;

interface Props {
  setToken: (token: string) => void;
}

const Hero = ({ setToken }: Props) => {
  const [slideIn, setSlideIn] = useState(false);
  const [textTransform, setTextTransform] = useState({ x: 0, y: 0 });

  useEffect(() => {
    setTimeout(() => setSlideIn(true), 300);
  }, []);

  return (
    <StyledHero
      onMouseMove={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        const { clientX, clientY } = e;
        const x = clientX / window.innerWidth;
        const y = clientY / window.innerHeight;
        const X_MOVEMENT = 10;
        const Y_MOVEMENT = 5;
        setTextTransform({
          x: Math.round((x * X_MOVEMENT - X_MOVEMENT / 2) * 10) / 10,
          y: Math.round((y * Y_MOVEMENT - Y_MOVEMENT / 2) * 10) / 10,
        });
      }}
    >
      <SvgContainer>
        <svg
          height="100%"
          viewBox="0 0 2223 953"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ transform: "translateX(-9%)" }}
        >
          <ellipse
            cx="1274.93"
            cy="652.897"
            rx="127.717"
            ry="270.842"
            transform="rotate(-172.054 1274.93 652.897)"
            fill="#221514"
          />
          <path
            d="M1339.37 387.795L1304.87 384.295L1297.87 389.795L1337.87 396.795L1339.37 387.795Z"
            fill="#221514"
          />
          <path
            d="M1274.75 924.795L1239.81 921.489L1231.87 907.795L1276.87 916.295L1274.75 924.795Z"
            fill="#221514"
          />
          <mask
            id="mask0_13_47"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="1170"
            y="387"
            width="265"
            height="538"
          >
            <ellipse
              cx="1302.73"
              cy="656.153"
              rx="127.717"
              ry="270.842"
              transform="rotate(-172.054 1302.73 656.153)"
              fill="#808080"
            />
          </mask>
          <g mask="url(#mask0_13_47)">
            <rect
              x="1518.87"
              y="968.795"
              width="462"
              height="620"
              transform="rotate(-180 1518.87 968.795)"
              fill="#FFC0CB"
            />
            <rect
              x="1036"
              y="928"
              width="544"
              height="403"
              transform="rotate(-90 1036 928)"
              fill="url(#pattern0)"
            />
          </g>
          <mask
            id="mask1_13_47"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="1170"
            y="385"
            width="1053"
            height="566"
          >
            <path
              d="M2222.37 385.795L1331.87 400.795L1274.37 922.295L2222.37 950.795L2222.37 385.795Z"
              fill="#008000"
            />
            <path
              d="M1176.24 638.497C1196.92 490.351 1270.31 378.161 1340.17 387.912C1410.03 397.663 1449.9 525.664 1429.22 673.809C1408.54 821.955 1335.14 934.145 1265.28 924.394C1195.43 914.643 1155.56 786.642 1176.24 638.497Z"
              fill="#008000"
            />
          </mask>
          <g mask="url(#mask1_13_47)">
            {/* Bottom text */}
            <g
              style={{
                transform: `translate(${textTransform.x}%, ${textTransform.y}%)`,
                transition: "transform 0.3s ",
              }}
            >
              <path
                style={{
                  transform: slideIn ? "translateX(0)" : "translateX(-100%)",
                  transition: "transform 1s ease-out",
                }}
                d="M716.16 604H634.88V716H716.16C745.12 716 770.56 698.08 770.56 660C770.56 621.92 745.12 604 716.16 604ZM705.28 691.84H663.68V628.16H705.28C727.04 628.16 741.76 632.8 741.76 660C741.76 687.2 727.04 691.84 705.28 691.84ZM843.835 695.36C825.595 695.36 811.195 690.4 808.155 675.36H909.915C909.915 632.48 881.275 620.16 845.435 620.16C807.195 620.16 780.155 634.24 780.155 668.96C780.155 703.52 807.995 717.6 843.835 717.6C878.715 717.6 902.075 706.24 908.315 682.24H881.115C874.235 691.84 862.715 695.36 843.835 695.36ZM845.275 640.96C862.555 640.96 875.995 644.64 880.635 657.92H809.115C813.435 644.64 826.555 640.96 845.275 640.96ZM994.749 620.16C974.429 620.16 957.949 625.76 947.709 636.48V588H920.349V716H947.709V701.28C957.949 712 974.429 717.6 994.749 717.6C1024.99 717.6 1050.91 704.96 1050.91 668.96C1050.91 632.96 1024.99 620.16 994.749 620.16ZM985.629 694.72C961.149 694.72 947.709 687.52 947.709 668.96C947.709 650.24 961.149 643.04 985.629 643.04C1010.11 643.04 1023.39 650.24 1023.39 668.96C1023.39 687.52 1010.11 694.72 985.629 694.72ZM1149.77 644.64V621.76H1105.13V594.4L1077.61 602.24V621.76H1052.81V644.64H1077.61V687.68C1077.61 708.48 1093.29 717.6 1117.61 717.6C1130.25 717.6 1140.65 716.8 1149.77 715.2V693.12C1138.73 694.72 1133.93 694.72 1125.29 694.72C1108.65 694.72 1105.13 690.08 1105.13 671.84V644.64H1149.77ZM1353.44 628.16V604H1235.04V716H1263.84V680.96H1343.84V656.64H1263.84V628.16H1353.44ZM1421.22 620.16C1401.54 620.16 1382.66 623.68 1363.46 629.92L1373.22 649.92C1392.58 644.16 1407.62 643.04 1419.94 643.04C1432.74 643.04 1455.78 644.48 1455.78 662.4C1443.46 658.24 1428.58 655.68 1412.42 655.68C1382.5 655.68 1355.62 663.36 1355.62 687.84C1355.62 709.12 1372.1 717.6 1398.5 717.6C1420.74 717.6 1439.14 712.48 1455.78 704.32V716H1483.3V668.48C1482.98 632.8 1460.58 620.16 1421.22 620.16ZM1455.78 686.72C1441.7 692.8 1421.22 697.44 1406.34 697.44C1392.1 697.44 1382.98 696.64 1382.98 686.72C1382.98 677.12 1395.3 673.6 1415.78 673.6C1433.22 673.6 1446.18 676.32 1455.78 679.36V686.72ZM1571.19 620.16C1553.59 620.16 1536.95 625.12 1522.87 637.76V621.76H1495.51V716H1522.87V659.52C1539.51 646.56 1557.11 643.04 1572.47 643.04C1580.47 643.04 1587.67 644 1596.63 646.24V623.36C1590.23 621.76 1582.39 620.16 1571.19 620.16ZM1771.37 620.16C1748.01 620.16 1731.21 628.32 1719.05 637.44C1711.85 624.32 1698.41 620.16 1684.17 620.16C1660.81 620.16 1645.45 628.96 1635.21 637.12V621.76H1607.85V716H1635.21V660.48C1643.05 652 1658.41 643.84 1674.25 643.84C1693.77 643.84 1697.13 654.24 1697.13 674.24V716H1724.49L1724.81 663.2C1724.81 661.44 1724.81 659.84 1724.65 658.24C1732.97 650.72 1747.05 643.84 1761.45 643.84C1780.97 643.84 1784.33 654.24 1784.33 674.24V716H1811.69L1812.01 663.2C1811.69 629.12 1792.49 620.16 1771.37 620.16ZM1824.88 588V611.84H1852.24V588H1824.88ZM1824.88 621.76V716H1852.24V621.76H1824.88ZM1948.21 620.16C1925.33 620.16 1906.77 627.68 1893.33 638.24V621.76H1865.97V716H1893.33V663.2C1901.81 653.28 1921.65 643.84 1940.05 643.84C1962.61 643.84 1969.33 654.24 1969.33 674.24V716H1996.85L1997.17 663.84C1996.85 629.12 1973.33 620.16 1948.21 620.16ZM2110.54 621.76V636.96C2101.1 626.4 2085.26 620.16 2062.86 620.16C2030.54 620.16 2007.5 634.24 2007.5 667.52C2007.5 700.8 2030.54 714.88 2062.86 714.88C2085.1 714.88 2100.94 708.64 2110.54 698.08C2109.42 722.24 2098.86 733.12 2070.54 733.12C2049.74 733.12 2028.62 728.48 2017.58 726.4V748.48C2026.7 750.88 2049.26 756 2076.62 756C2112.3 756 2138.06 739.36 2138.06 700.96V621.76H2110.54ZM2072.78 692C2047.02 692 2034.86 684.8 2034.86 667.52C2034.86 650.24 2047.02 643.04 2072.78 643.04C2098.54 643.04 2110.54 650.24 2110.54 667.52C2110.54 684.8 2098.54 692 2072.78 692Z"
                fill="#221514"
              />
            </g>
          </g>
          <path
            d="M1341 489.717C1331.47 489.717 1326.78 484.086 1326.78 476C1326.78 484.086 1321.62 489.717 1313 489.717C1321.62 489.717 1326.78 494.77 1326.78 503C1326.78 494.683 1331.52 489.717 1341 489.717Z"
            fill="#221514"
          />
          <path
            d="M1546 512.717C1536.47 512.717 1531.78 507.086 1531.78 499C1531.78 507.086 1526.62 512.717 1518 512.717C1526.62 512.717 1531.78 517.77 1531.78 526C1531.78 517.683 1536.52 512.717 1546 512.717Z"
            fill="#221514"
          />
          <path
            d="M1518 466.16C1510.85 466.16 1507.34 461.989 1507.34 456C1507.34 461.989 1503.46 466.16 1497 466.16C1503.46 466.16 1507.34 469.904 1507.34 476C1507.34 469.84 1510.89 466.16 1518 466.16Z"
            fill="#221514"
          />
          <path
            d="M1526 556.128C1520.21 556.128 1517.37 552.791 1517.37 548C1517.37 552.791 1514.23 556.128 1509 556.128C1514.23 556.128 1517.37 559.123 1517.37 564C1517.37 559.072 1520.25 556.128 1526 556.128Z"
            fill="#221514"
          />
          <path
            d="M1310 822.193C1301.49 822.193 1297.31 817.187 1297.31 810C1297.31 817.187 1292.69 822.193 1285 822.193C1292.69 822.193 1297.31 826.684 1297.31 834C1297.31 826.607 1301.54 822.193 1310 822.193Z"
            fill="#221514"
          />
          <path
            d="M1378 512.652C1371.19 512.652 1367.85 508.69 1367.85 503C1367.85 508.69 1364.15 512.652 1358 512.652C1364.15 512.652 1367.85 516.209 1367.85 522C1367.85 516.148 1371.23 512.652 1378 512.652Z"
            fill="#221514"
          />
          <path
            d="M1242.43 649.379C1252.76 575.419 1276.24 510.483 1305.8 465.285C1335.42 420.015 1370.92 394.856 1405.24 399.647C1439.56 404.438 1466.81 438.355 1482.9 490.005C1498.96 541.572 1503.76 610.456 1493.43 684.416C1483.11 758.376 1459.63 823.312 1430.06 868.51C1400.45 913.78 1364.95 938.939 1330.63 934.148C1296.31 929.357 1269.06 895.44 1252.97 843.79C1236.91 792.223 1232.11 723.339 1242.43 649.379Z"
            stroke="#221514"
            strokeWidth="2"
          />
          <mask
            id="mask2_13_47"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="1312"
            y="736"
            width="118"
            height="147"
          >
            <path
              d="M1312.87 856.295L1335.87 882.295L1429.87 787.295L1357.87 736.795L1312.87 856.295Z"
              fill="#FF0000"
            />
          </mask>
          <g mask="url(#mask2_13_47)">
            <path
              d="M1148.94 635.31C1159.27 561.294 1182.77 496.284 1212.39 451.011C1242.03 405.703 1277.68 380.318 1312.31 385.152C1346.93 389.985 1374.27 424.163 1390.37 475.856C1406.46 527.508 1411.26 596.468 1400.93 670.485C1390.6 744.501 1367.1 809.511 1337.48 854.784C1307.84 900.092 1272.19 925.477 1237.56 920.643C1202.93 915.81 1175.59 881.632 1159.49 829.939C1143.4 778.287 1138.61 709.327 1148.94 635.31Z"
              stroke="white"
            />
          </g>
          <ellipse
            cx="947.433"
            cy="299.897"
            rx="127.717"
            ry="270.842"
            transform="rotate(7.94635 947.433 299.897)"
            fill="#221514"
          />
          <path
            d="M883 565L917.5 568.5L924.5 563L884.5 556L883 565Z"
            fill="#221514"
          />
          <path
            d="M947.618 28L982.559 31.3056L990.5 45L945.5 36.5L947.618 28Z"
            fill="#221514"
          />
          <mask
            id="mask3_13_47"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="787"
            y="27"
            width="265"
            height="539"
          >
            <ellipse
              cx="919.64"
              cy="296.642"
              rx="127.717"
              ry="270.842"
              transform="rotate(7.94635 919.64 296.642)"
              fill="#808080"
            />
          </mask>
          <g mask="url(#mask3_13_47)">
            <rect x="703" y="2" width="426" height="600" fill="#26004D" />
            <rect
              x="784"
              y="567"
              width="539"
              height="402"
              transform="rotate(-90 784 567)"
              fill="url(#pattern1)"
            />
          </g>
          <path
            d="M979.934 303.416C969.61 377.376 946.132 442.312 916.563 487.51C886.947 532.78 851.45 557.939 817.129 553.148C782.807 548.357 755.557 514.44 739.47 462.79C723.408 411.223 718.609 342.339 728.933 268.379C739.257 194.419 762.735 129.483 792.304 84.2849C821.92 39.0148 857.416 13.8559 891.738 18.6467C926.059 23.4375 953.31 57.3551 969.397 109.005C985.459 160.572 990.257 229.455 979.934 303.416Z"
            stroke="#221514"
            strokeWidth="2"
          />
          <mask
            id="mask4_13_47"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="792"
            y="70"
            width="118"
            height="146"
          >
            <path
              d="M909.5 96.5L886.5 70.5L792.5 165.5L864.5 216L909.5 96.5Z"
              fill="#FF0000"
            />
          </mask>
          <g mask="url(#mask4_13_47)">
            <path
              d="M1073.43 317.485C1063.1 391.501 1039.6 456.511 1009.98 501.784C980.34 547.092 944.685 572.477 910.06 567.643C875.434 562.81 848.093 528.632 831.992 476.939C815.904 425.287 811.106 356.327 821.438 282.31C831.77 208.294 855.268 143.284 884.885 98.0111C914.526 52.7027 950.181 27.3183 984.807 32.1515C1019.43 36.9848 1046.77 71.1625 1062.87 122.856C1078.96 174.508 1083.76 243.468 1073.43 317.485Z"
              stroke="white"
            />
          </g>
          <mask
            id="cool_mask"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="2"
            width="1052"
            height="565"
          >
            <path d="M0 567L890.5 552L948 30.5L0 2V567Z" fill="#008000" />
            <path
              d="M1046.13 314.298C1025.45 462.444 952.056 574.634 882.197 564.883C812.338 555.132 772.47 427.131 793.149 278.986C813.828 130.84 887.224 18.6495 957.083 28.4008C1026.94 38.1521 1066.81 166.153 1046.13 314.298Z"
              fill="#008000"
            />
          </mask>
          <g mask="url(#cool_mask)">
            {/* Top text */}
            <g
              style={{
                transform: `translate(${textTransform.x}%, ${textTransform.y}%)`,
                transition: "transform 0.3s",
              }}
            >
              <path
                style={{
                  transform: slideIn ? "translateX(0)" : "translateX(-100%)",
                  transition: "transform 1s ease-out",
                }}
                d="M562.16 220H480.88V332H562.16C591.12 332 616.56 314.08 616.56 276C616.56 237.92 591.12 220 562.16 220ZM551.28 307.84H509.68V244.16H551.28C573.04 244.16 587.76 248.8 587.76 276C587.76 303.2 573.04 307.84 551.28 307.84ZM689.835 311.36C671.595 311.36 657.195 306.4 654.155 291.36H755.915C755.915 248.48 727.275 236.16 691.435 236.16C653.195 236.16 626.155 250.24 626.155 284.96C626.155 319.52 653.995 333.6 689.835 333.6C724.715 333.6 748.075 322.24 754.315 298.24H727.115C720.235 307.84 708.715 311.36 689.835 311.36ZM691.275 256.96C708.555 256.96 721.995 260.64 726.635 273.92H655.115C659.435 260.64 672.555 256.96 691.275 256.96ZM840.749 236.16C820.429 236.16 803.949 241.76 793.709 252.48V204H766.349V332H793.709V317.28C803.949 328 820.429 333.6 840.749 333.6C870.989 333.6 896.909 320.96 896.909 284.96C896.909 248.96 870.989 236.16 840.749 236.16ZM831.629 310.72C807.149 310.72 793.709 303.52 793.709 284.96C793.709 266.24 807.149 259.04 831.629 259.04C856.109 259.04 869.389 266.24 869.389 284.96C869.389 303.52 856.109 310.72 831.629 310.72ZM995.771 260.64V237.76H951.131V210.4L923.611 218.24V237.76H898.811V260.64H923.611V303.68C923.611 324.48 939.291 333.6 963.611 333.6C976.251 333.6 986.651 332.8 995.771 331.2V309.12C984.731 310.72 979.931 310.72 971.291 310.72C954.651 310.72 951.131 306.08 951.131 287.84V260.64H995.771ZM1199.44 244.16V220H1081.04V332H1109.84V296.96H1189.84V272.64H1109.84V244.16H1199.44ZM1267.22 236.16C1247.54 236.16 1228.66 239.68 1209.46 245.92L1219.22 265.92C1238.58 260.16 1253.62 259.04 1265.94 259.04C1278.74 259.04 1301.78 260.48 1301.78 278.4C1289.46 274.24 1274.58 271.68 1258.42 271.68C1228.5 271.68 1201.62 279.36 1201.62 303.84C1201.62 325.12 1218.1 333.6 1244.5 333.6C1266.74 333.6 1285.14 328.48 1301.78 320.32V332H1329.3V284.48C1328.98 248.8 1306.58 236.16 1267.22 236.16ZM1301.78 302.72C1287.7 308.8 1267.22 313.44 1252.34 313.44C1238.1 313.44 1228.98 312.64 1228.98 302.72C1228.98 293.12 1241.3 289.6 1261.78 289.6C1279.22 289.6 1292.18 292.32 1301.78 295.36V302.72ZM1417.19 236.16C1399.59 236.16 1382.95 241.12 1368.87 253.76V237.76H1341.51V332H1368.87V275.52C1385.51 262.56 1403.11 259.04 1418.47 259.04C1426.47 259.04 1433.67 260 1442.63 262.24V239.36C1436.23 237.76 1428.39 236.16 1417.19 236.16ZM1617.37 236.16C1594.01 236.16 1577.21 244.32 1565.05 253.44C1557.85 240.32 1544.41 236.16 1530.17 236.16C1506.81 236.16 1491.45 244.96 1481.21 253.12V237.76H1453.85V332H1481.21V276.48C1489.05 268 1504.41 259.84 1520.25 259.84C1539.77 259.84 1543.13 270.24 1543.13 290.24V332H1570.49L1570.81 279.2C1570.81 277.44 1570.81 275.84 1570.65 274.24C1578.97 266.72 1593.05 259.84 1607.45 259.84C1626.97 259.84 1630.33 270.24 1630.33 290.24V332H1657.69L1658.01 279.2C1657.69 245.12 1638.49 236.16 1617.37 236.16ZM1670.88 204V227.84H1698.24V204H1670.88ZM1670.88 237.76V332H1698.24V237.76H1670.88ZM1794.21 236.16C1771.33 236.16 1752.77 243.68 1739.33 254.24V237.76H1711.97V332H1739.33V279.2C1747.81 269.28 1767.65 259.84 1786.05 259.84C1808.61 259.84 1815.33 270.24 1815.33 290.24V332H1842.85L1843.17 279.84C1842.85 245.12 1819.33 236.16 1794.21 236.16ZM1956.54 237.76V252.96C1947.1 242.4 1931.26 236.16 1908.86 236.16C1876.54 236.16 1853.5 250.24 1853.5 283.52C1853.5 316.8 1876.54 330.88 1908.86 330.88C1931.1 330.88 1946.94 324.64 1956.54 314.08C1955.42 338.24 1944.86 349.12 1916.54 349.12C1895.74 349.12 1874.62 344.48 1863.58 342.4V364.48C1872.7 366.88 1895.26 372 1922.62 372C1958.3 372 1984.06 355.36 1984.06 316.96V237.76H1956.54ZM1918.78 308C1893.02 308 1880.86 300.8 1880.86 283.52C1880.86 266.24 1893.02 259.04 1918.78 259.04C1944.54 259.04 1956.54 266.24 1956.54 283.52C1956.54 300.8 1944.54 308 1918.78 308Z"
                fill="#221514"
              />
            </g>
          </g>
          <path
            d="M904 119.717C894.466 119.717 889.785 114.086 889.785 106C889.785 114.086 884.615 119.717 876 119.717C884.615 119.717 889.785 124.77 889.785 133C889.785 124.683 894.523 119.717 904 119.717Z"
            fill="#221514"
          />
          <path
            d="M756 105.717C746.466 105.717 741.785 100.086 741.785 92C741.785 100.086 736.615 105.717 728 105.717C736.615 105.717 741.785 110.77 741.785 119C741.785 110.683 746.523 105.717 756 105.717Z"
            fill="#221514"
          />
          <path
            d="M696 129.144C689.53 129.144 686.354 125.39 686.354 120C686.354 125.39 682.846 129.144 677 129.144C682.846 129.144 686.354 132.513 686.354 138C686.354 132.456 689.569 129.144 696 129.144Z"
            fill="#221514"
          />
          <path
            d="M897 479.209C887.806 479.209 883.292 473.786 883.292 466C883.292 473.786 878.308 479.209 870 479.209C878.308 479.209 883.292 484.075 883.292 492C883.292 483.991 887.862 479.209 897 479.209Z"
            fill="#221514"
          />
          <path
            d="M854 456.16C846.509 456.16 842.831 451.989 842.831 446C842.831 451.989 838.769 456.16 832 456.16C838.769 456.16 842.831 459.904 842.831 466C842.831 459.84 846.554 456.16 854 456.16Z"
            fill="#221514"
          />
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image0_13_47"
                transform="translate(0 -0.00620347) scale(0.00142857 0.00192839)"
              />
            </pattern>
            <pattern
              id="pattern1"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image1_13_47"
                transform="translate(0 -0.00279851) scale(0.00142857 0.00191542)"
              />
            </pattern>
            <image
              id="image0_13_47"
              width="700"
              height="525"
              xlinkHref={firstImage}
            />
            <image
              id="image1_13_47"
              width="700"
              height="525"
              xlinkHref={secondImage}
            />
          </defs>
        </svg>
      </SvgContainer>
      <Cubes setToken={setToken} />
      <ScrollButton />
    </StyledHero>
  );
};

export default Hero;
